<template>
  <div>
    <!-- Enhanced Hospital Header Card with gradient -->
    <!-- <b-card class="hospital-header-card shadow-sm mb-4">
      <div class="text mb-3 pt-1">
        <div class="arabic-name">{{ $brand.nameArFull }}</div>
        <div class="english-name">{{ $brand.nameEnFull }}</div>

        <b-img
          class="mb-2 logo pulse-animation"
          :src="hospitalLogo"
          width="200"
          height="200"
          style=""
        />
      </div>
    </b-card> -->

    <!-- Enhanced Main Form Card -->
    <b-card class="form-card shadow">
      <!-- Form Title with Icon -->
      <div class="form-header mb-4">
        <feather-icon
          icon="UserPlusIcon"
          size="28"
          class="text-primary mr-2"
        />
        <h2 class="mb-0">
          {{ $t("reception.register-patient") }}
        </h2>
      </div>

      <b-row>
        <!-- Section Header with divider -->
        <b-col cols="12">
          <div class="section-divider">
            <feather-icon
              icon="UserIcon"
              size="20"
              class="section-icon"
            />
            <h4 class="section-title">
              {{ $t("reception.personal-info") }}
            </h4>
          </div>
        </b-col>
        <b-col
          md="6"
          cols="12"
        >
          <b-form-group
            :label="$t('common.name')"
            label-for="Name"
            class="required"
          >
            <b-form-input
              id="Name"
              v-model="addForm.name"
              :state="errorForm.name ? false : null"
              :placeholder="$t('common.name')"
            />
            <small class="text-danger">{{ errorForm.name }}</small>
          </b-form-group>
        </b-col>
        <b-col
          md="3"
          cols="12"
        >
          <b-form-group
            class="required"
            :label="$t('clinic.mother-name')"
            label-for="mother_name"
          >
            <b-form-input
              id="mother_name"
              v-model="addForm.mother_name"
              :state="errorForm.mother_name ? false : null"
              :placeholder="$t('clinic.mother-name')"
            />
            <small class="text-danger">{{ errorForm.mother_name }}</small>
          </b-form-group>
        </b-col>
        <b-col
          md="3"
          cols="12"
        >
          <b-form-group
            :label="$t('reception.gender')"
            label-for="Gender"
            class="required"
          >
            <v-select
              v-model="addForm.gender"
              :options="genderOption"
              :placeholder="$t('reception.gender')"
            />
            <small class="text-danger">{{ errorForm.gender }}</small>
          </b-form-group>
        </b-col>

        <b-col
          md="6"
          cols="12"
        >
          <b-form-group
            :label="$t('reception.phone')"
            label-for="phoneNumber"
            class="required"
          >
            <VuePhoneNumberInput
              v-model="addForm.phone"
              default-country-code="IQ"
              :error="
                addForm.phone ? isNotValid || addForm.phone[0] != 0 : false
              "
              @update="
                (obj) => {
                  showPhoneObj(obj, 'countryCallingCode');
                }
              "
            />
            <small class="text-danger">{{ errorForm.phone }}</small>
          </b-form-group>
        </b-col>
        <b-col
          md="3"
          cols="12"
        >
          <b-form-group
            :label="$t('reception.age')"
            class="required"
            label-for="age_input"
          >
            <b-form-input
              id="age_input"
              v-model.number="patientAge"
              type="number"
              min="0"
              max="150"
              :state="errorForm.birth_date ? false : null"
              :placeholder="$t('reception.age')"
              @input="calculateBirthDateFromAge"
            />
            <small class="text-muted">{{
              $t("reception.age-will-calculate-birth-year")
            }}</small>
            <small class="text-danger">{{ errorForm.birth_date }}</small>
          </b-form-group>
        </b-col>
        <b-col
          md="3"
          cols="12"
        >
          <AutoComplete
            v-model="addForm.governorate_id"
            class="required"
            :label="$t('reception.governorate')"
            :placeholder="$t('reception.governorate')"
            :serializer="(val) => val.id"
            param-query="search"
            endpoint="governorate"
            text-title="name"
          />
          <small class="text-danger">{{ errorForm.governorate_id }}</small>
        </b-col>

        <!-- Toggle for Additional Information with dropdown arrow -->
        <b-col cols="12">
          <b-button
            v-b-toggle.additional-info
            variant="primary"
            block
            class="text-left d-flex align-items-center justify-content-between additional-info-btn"
          >
            <div class="d-flex align-items-center">
              <feather-icon
                icon="InfoIcon"
                size="18"
                class="mr-2"
              />
              <span>{{ $t("reception.show-additional-info") }}</span>
            </div>
            <feather-icon
              icon="ChevronDownIcon"
              size="18"
              class="when-closed"
            />
            <feather-icon
              icon="ChevronUpIcon"
              size="18"
              class="when-open"
            />
          </b-button>
        </b-col>

        <!-- Additional Information Fields with collapse -->
        <b-col cols="12">
          <b-collapse
            id="additional-info"
            v-model="showAdditionalInfo"
            class="mt-3"
          >
            <b-row>
              <!-- Row 1: National ID, City Name, Occupation -->
              <b-col
                md="4"
                cols="12"
              >
                <b-form-group
                  :label="$t('reception.national-id')"
                  label-for="national_id"
                >
                  <b-form-input
                    id="national_id"
                    v-model="addForm.national_id"
                    placeholder="Enter National ID"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="4"
                cols="12"
              >
                <b-form-group
                  :label="$t('reception.city-name')"
                  label-for="City"
                >
                  <b-form-input
                    id="City"
                    v-model="addForm.city_name"
                    :placeholder="$t('reception.city-name')"
                  />
                </b-form-group>
                <small class="text-danger">{{ errorForm.city_name }}</small>
              </b-col>
              <b-col
                md="4"
                cols="12"
              >
                <b-form-group
                  :label="$t('common.Occupation')"
                  label-for="Name"
                >
                  <b-form-input
                    id="Name"
                    v-model="addForm.occupation"
                    :placeholder="$t('common.Occupation')"
                  />
                </b-form-group>
              </b-col>

              <!-- Row 2: Marital Status, Educational Level, Residence Type -->
              <b-col
                md="4"
                cols="12"
              >
                <b-form-group
                  :label="$t('reception.martial-status')"
                  label-for="status"
                >
                  <v-select
                    v-model="addForm.marital_status"
                    :options="maritalStatusOptions"
                    :placeholder="$t('reception.martial-status')"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="4"
                cols="12"
              >
                <b-form-group
                  :label="$t('reception.educational-level')"
                  label-for="status"
                >
                  <v-select
                    v-model="addForm.education_level"
                    :options="educationalLevelOptions"
                    :placeholder="$t('reception.educational-level')"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="4"
                cols="12"
              >
                <b-form-group
                  :label="$t('reception.residence-type')"
                  label-for="Residence"
                >
                  <v-select
                    v-model="addForm.residence_type"
                    :options="residenceOptions"
                    :placeholder="$t('reception.residence-type')"
                  />
                </b-form-group>
              </b-col>

              <!-- Row 3: Judiciary Name, Township, District Name -->
              <b-col
                md="4"
                cols="12"
              >
                <b-form-group
                  :label="$t('reception.judiciary-name')"
                  label-for="Judiciary"
                >
                  <b-form-input
                    id="Governorate"
                    v-model="addForm.judiciary_name"
                    :placeholder="$t('reception.judiciary-name')"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="4"
                cols="12"
              >
                <b-form-group
                  :label="$t('reception.township')"
                  label-for="Township"
                >
                  <b-form-input
                    id="Township"
                    v-model="addForm.town_name"
                    :placeholder="$t('reception.township')"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="4"
                cols="12"
              >
                <b-form-group
                  :label="$t('reception.district-name')"
                  label-for="district_name"
                >
                  <b-form-input
                    id="district_name"
                    v-model="addForm.district_name"
                    type="number"
                    :placeholder="$t('reception.district-name')"
                  />
                </b-form-group>
              </b-col>

              <!-- Row 4: Street Name, Building Number, Paper Number -->
              <b-col
                md="4"
                cols="12"
              >
                <b-form-group
                  :label="$t('reception.street-name')"
                  label-for="street_name"
                >
                  <b-form-input
                    id="street_name"
                    v-model="addForm.street_name"
                    type="number"
                    :placeholder="$t('reception.street-name')"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="4"
                cols="12"
              >
                <b-form-group
                  :label="$t('reception.building-number')"
                  label-for="building_number"
                >
                  <b-form-input
                    id="building_number"
                    v-model="addForm.building_number"
                    :placeholder="$t('reception.building-number')"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="4"
                cols="12"
              >
                <b-form-group
                  :label="$t('reception.paper-number')"
                  label-for="paper_number"
                >
                  <b-form-input
                    id="paper_number"
                    v-model="addForm.document_page_number"
                    :placeholder="$t('reception.paper-number')"
                  />
                </b-form-group>
              </b-col>

              <!-- Row 5: Document Number, DPCS -->
              <b-col
                md="4"
                cols="12"
              >
                <b-form-group
                  :label="$t('reception.document-number')"
                  label-for="Document_number"
                >
                  <b-form-input
                    id="document_number"
                    v-model="addForm.document_number"
                    :placeholder="$t('reception.document-number')"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="4"
                cols="12"
              >
                <b-form-group
                  :label="$t('reception.dpcs')"
                  label-for="Document_number_dpcs"
                >
                  <b-form-input
                    id="document_number_dpcs"
                    v-model="addForm.department_of_civil_status"
                    :placeholder="$t('reception.dpcs')"
                  />
                </b-form-group>
              </b-col>

              <!-- Companion Information (Moved to Additional Info) -->
              <b-col
                md="6"
                cols="12"
              >
                <b-form-group
                  :label="$t('reception.companion-name')"
                  label-for="companion_name"
                >
                  <b-form-input
                    id="companion_name"
                    v-model="addForm.full_companion_name"
                    :placeholder="$t('reception.companion-name')"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                cols="12"
              >
                <b-form-group
                  :label="$t('reception.companion-phone')"
                  label-for="companion_phoneNumber"
                >
                  <VuePhoneNumberInput
                    v-model="addForm.companion_phone"
                    default-country-code="IQ"
                    :error="
                      addForm.companion_phone
                        ? isNotValid || addForm.companion_phone[0] != 0
                        : false
                    "
                    @update="
                      (obj) => {
                        showPhoneObj(obj, 'countryCallingCode');
                      }
                    "
                  />
                </b-form-group>
              </b-col>

              <!-- Next of Kin Information (Moved to Additional Info) -->
              <b-col
                md="6"
                cols="12"
              >
                <b-form-group
                  :label="$t('reception.next-kin-name')"
                  label-for="next_kin_name"
                >
                  <b-form-input
                    id="next_kin_name"
                    v-model="addForm.next_of_kin_name"
                    :placeholder="$t('reception.next-kin-name')"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                cols="12"
              >
                <b-form-group
                  :label="$t('reception.next-kin-phone')"
                  label-for="next_kin_phoneNumber"
                >
                  <VuePhoneNumberInput
                    v-model="addForm.next_of_kin_phone_number"
                    default-country-code="IQ"
                    :error="
                      addForm.next_of_kin_phone_number
                        ? isNotValid || addForm.next_of_kin_phone_number[0] != 0
                        : false
                    "
                    @update="
                      (obj) => {
                        showPhoneObj(obj, 'countryCallingCode');
                      }
                    "
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-collapse>
        </b-col>

        <!-- Patient Card Information Section -->
        <b-col
          v-if="!patientId"
          cols="12"
        >
          <div class="section-divider">
            <feather-icon
              icon="CreditCardIcon"
              size="20"
              class="section-icon"
            />
            <h4 class="section-title">
              {{ $t("reception.patient-card-info") }}
            </h4>
          </div>
        </b-col>
        <b-col
          v-if="!patientId"
          md="12"
          cols="12"
        >
          <b-form-group
            :label="$t('reception.card-type')"
            label-for="Type"
          >
            <div class="radio-group">
              <!-- IN Option -->
              <input
                id="type-in"
                v-model="addForm.type"
                type="radio"
                name="card_type"
                value="IN"
                class="radio-input"
                style="position: absolute; opacity: 0"
              >
              <label
                for="type-in"
                class="radio-label w-100"
              >
                <feather-icon
                  icon="HomeIcon"
                  size="24"
                  class="mr-2"
                />
                <span class="radio-text">{{
                  $t("reception.card-type-in")
                }}</span>
              </label>

              <!-- NICU Option -->
              <input
                id="type-nicu"
                v-model="addForm.type"
                type="radio"
                name="card_type"
                value="NICU"
                class="radio-input"
                style="position: absolute; opacity: 0"
              >
              <label
                for="type-nicu"
                class="radio-label w-100"
              >
                <feather-icon
                  icon="HeartIcon"
                  size="24"
                  class="mr-2"
                />
                <span class="radio-text">{{
                  $t("reception.card-type-nicu")
                }}</span>
              </label>

              <!-- EMERGENCY Option -->
              <input
                id="type-emergency"
                v-model="addForm.type"
                type="radio"
                name="card_type"
                value="EMERGENCY"
                class="radio-input"
                style="position: absolute; opacity: 0"
              >
              <label
                for="type-emergency"
                class="radio-label w-100"
              >
                <feather-icon
                  icon="AlertCircleIcon"
                  size="24"
                  class="mr-2"
                />
                <span class="radio-text">{{
                  $t("reception.card-type-emergency")
                }}</span>
              </label>

              <!-- CLINIC Option -->
              <input
                id="type-clinic"
                v-model="addForm.type"
                type="radio"
                name="card_type"
                value="CLINIC"
                class="radio-input"
                style="position: absolute; opacity: 0"
              >
              <label
                for="type-clinic"
                class="radio-label w-100"
              >
                <feather-icon
                  icon="ActivityIcon"
                  size="24"
                  class="mr-2"
                />
                <span class="radio-text">{{
                  $t("reception.card-type-clinic")
                }}</span>
              </label>

              <!-- LAB Option -->
              <input
                id="type-lab"
                v-model="addForm.type"
                type="radio"
                name="card_type"
                value="LAB"
                class="radio-input"
                style="position: absolute; opacity: 0"
              >
              <label
                for="type-lab"
                class="radio-label w-100"
              >
                <feather-icon
                  icon="FlaskIcon"
                  size="24"
                  class="mr-2"
                />
                <span class="radio-text">{{
                  $t("reception.card-type-lab")
                }}</span>
              </label>
            </div>
            <small class="text-danger">{{ errorForm.type }}</small>
          </b-form-group>
          <b-form-group
            v-if="addForm.type === 'IN'"
            :label="$t('reception.treatment-type')"
            label-for="treatmentType"
            class="required"
          >
            <div class="radio-group">
              <!-- None Option -->
              <input
                id="none"
                v-model="treatment_type"
                type="radio"
                name="treatment_type"
                value="None"
                class="radio-input"
                style="position: absolute; opacity: 0"
              >
              <label
                for="none"
                class="radio-label w-100"
              >
                <span class="radio-text">{{ $t("common.none") }}</span>
              </label>

              <!-- Bed Rest Option -->
              <input
                id="bedrest"
                v-model="treatment_type"
                type="radio"
                name="treatment_type"
                value="Bed Rest"
                class="radio-input"
                style="position: absolute; opacity: 0"
              >
              <label
                for="bedrest"
                class="radio-label w-100"
              >
                <span class="radio-text">{{ $t("reception.bed-rest") }}</span>
              </label>

              <!-- Surgery Option -->
              <input
                id="surgery"
                v-model="treatment_type"
                type="radio"
                name="treatment_type"
                value="Surgery"
                class="radio-input"
                style="position: absolute; opacity: 0"
              >
              <label
                for="surgery"
                class="radio-label w-100"
              >
                <span class="radio-text">{{ $t("reception.surgery") }}</span>
              </label>
            </div>
          </b-form-group>
        </b-col>
        <div
          v-if="addForm.type === 'IN' && treatment_type"
          class="mt-2 mt-md-0 w-100 mx-1"
        >
          <b-row>
            <b-col
              md="12"
              cols="12"
              class="mt-3"
            >
              <b-form-group :label="$t('common.doctors')">
                <v-select
                  v-model="selectedDoctors"
                  :options="doctors"
                  multiple
                  label="name"
                  :reduce="(doctor) => doctor"
                  :close-on-select="false"
                  @input="formatForQuery"
                >
                  <template
                    v-if="treatment_type === 'Surgery'"
                    #option="{ name, type }"
                  >
                    <b style="margin: 0">
                      {{ name }}
                      <span
                        v-if="type == 'surgeon'"
                        class="text-primary"
                      >
                        ({{ $t("hospital.surgeon") }})
                      </span>
                      <span
                        v-if="type == 'anesthetist'"
                        class="text-primary"
                      >
                        ({{ $t("hospital.anesthetist") }})
                      </span>
                    </b>
                  </template>
                  <template
                    v-if="treatment_type === 'Surgery'"
                    #selected-option="{ name, type }"
                  >
                    <b style="margin: 0">
                      {{ name }}
                      <span
                        v-if="type == 'surgeon'"
                        class="text-success"
                      >
                        ({{ $t("hospital.surgeon") }})
                      </span>
                      <span
                        v-if="type == 'anesthetist'"
                        class="text-success"
                      >
                        ({{ $t("hospital.anesthetist") }})
                      </span>
                    </b>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div
          v-if="addForm.type === 'IN' && treatment_type === 'Surgery'"
          class="mt-2 mt-md-0 w-100 mx-1"
        >
          <b-row>
            <b-col
              md="12"
              cols="12"
              class="mb-1"
            >
              <div class="my-1">
                <AutoComplete
                  v-model="selectedAvailableSurgeries"
                  :label="$t('reception.available-surgeries')"
                  :placeholder="$t('reception.available-surgeries')"
                  endpoint="surgery"
                  text-title="title"
                  param-query="search"
                  :serializer="(val) => val"
                  :close-on-select="true"
                >
                  <template #list-footer>
                    <b-button
                      variant="success"
                      size="sm"
                      block
                      class="m-1"
                      @click="showCreateSurgeryModal"
                    >
                      {{ $t("reception.create-surgery") }}
                    </b-button>
                  </template>
                </AutoComplete>
              </div>
            </b-col>

            <!-- Surgery price input shown when IN patient and Surgery selected -->
            <b-col
              md="12"
              cols="12"
              class="mb-1"
            >
              <b-form-group
                :label="$t('reception.surgery-price') || 'Surgery Price'"
              >
                <b-form-input
                  v-model.number="patientSurgeryPrice"
                  type="number"
                  min="0.01"
                  step="0.01"
                  :state="errorForm.surgery_price ? false : null"
                  :placeholder="
                    $t('reception.surgery-price') || 'Surgery Price'
                  "
                  @input="validateSurgeryPrice"
                />
                <small class="text-danger">{{ errorForm.surgery_price }}</small>
              </b-form-group>
            </b-col>

            <!-- Surgery date/time input -->
            <b-col
              md="12"
              cols="12"
              class="mb-1"
            >
              <b-form-group
                :label="
                  $t('surgery.surgery_date_time') || 'Surgery Date & Time'
                "
              >
                <b-form-input
                  v-model="patientSurgeryDateTime"
                  type="datetime-local"
                  :min="minDateTime"
                  :state="errorForm.surgery_date_time ? false : null"
                  :placeholder="
                    $t('surgery.surgery_date_time') || 'Surgery Date & Time'
                  "
                  @input="validateSurgeryDateTime"
                />
                <small class="text-danger">{{
                  errorForm.surgery_date_time
                }}</small>
              </b-form-group>
            </b-col>

            <b-modal
              id="modal-create-surgery"
              :title="$t('reception.create-surgery')"
              ok-only
              centered
              size="lg"
              :no-close-on-backdrop="true"
            >
              <div>
                <b-form-group :label="$t('common.title')">
                  <b-form-input v-model="surgeryForm.title" />
                </b-form-group>
                <b-form-group :label="$t('common.description')">
                  <b-form-textarea v-model="surgeryForm.description" />
                </b-form-group>
                <b-form-group :label="$t('reception.type')">
                  <v-select
                    v-model="surgeryForm.type"
                    :options="surgeryTypesList"
                    label="text"
                    :reduce="(option) => option.value"
                  />
                </b-form-group>
                <SurgeryCategorySelect
                  v-model="surgeryForm.surgery_category_id"
                />
              </div>
              <template #modal-footer="{}">
                <b-button
                  ref="button"
                  variant="primary"
                  class="m-0"
                  :disabled="loading"
                  block
                  @click="createSurgery"
                >
                  <span v-if="!loading">{{ $t("common.add") }}</span>
                  <b-spinner
                    v-else
                    small
                  />
                </b-button>
              </template>
            </b-modal>

            <!-- <b-col class="d-flex align-items-center w-full" md="2" cols="12">
                <b-button
                  class="mx-1 w-full"
                  variant="primary"
                  size="sm"
                  @click="addDoctor"
                  >+</b-button
                >
                <b-button
                  :disabled="index === 0"
                  size="sm"
                  variant="danger"
                  @click="removeDoctor(index)"
                  >X</b-button
                >
              </b-col> -->
            <!-- <b-col md="6" cols="12">
                <b-form-group
                  :label="$t('reception.patient-case')"
                  label-for="patient_case"
                >
                  <b-form-input
                    id="patient_case"
                    v-model="addForm.patient_case"
                    :placeholder="$t('reception.patient-case')"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6" cols="12">
                <b-form-group
                  :label="$t('reception.diagnosis')"
                  label-for="diagnosis"
                >
                  <b-form-input
                    id="diagnosis"
                    v-model="addForm.diagnosis"
                    :placeholder="$t('reception.diagnosis')"
                  />
                </b-form-group>
              </b-col> -->
          </b-row>
        </div>
        <b-col
          v-if="addForm.type === 'IN'"
          md="12"
          cols="12"
        >
          <AutoComplete
            v-model="addForm.room_id"
            :label="$t('reception.room')"
            :placeholder="$t('reception.room')"
            :serializer="(val) => val.id"
            param-query="search"
            endpoint="available-room"
            text-title="name"
          />
        </b-col>
        <!--  -->
        <b-col
          v-if="addForm.type === 'NICU'"
          cols="12"
        >
          <b-form-group
            :label="$t('reception.child_name')"
            label-for="child_name"
            class="required"
          >
            <b-form-input
              id="child_name"
              v-model="addForm.child_name"
              :state="errorForm.child_name ? false : null"
              :placeholder="$t('reception.child_name')"
            />
            <small class="text-danger">{{ errorForm.child_name }}</small>
            <small
              style="font-size: 13px"
              class="d-block mt-1 font-weight-bold"
            >
              <b-icon-info-circle class="mr-1" />
              {{ $t("reception.child_name_note") }}
            </small>
          </b-form-group>
        </b-col>
        <b-col
          v-if="addForm.type === 'NICU'"
          md="12"
          cols="12"
        >
          <b-form-group :label="$t('common.doctors')">
            <v-select
              v-model="selectedDoctors"
              :options="doctors"
              multiple
              label="name"
              :reduce="(doctor) => doctor"
              :close-on-select="false"
              @input="formatForQuery"
            />
          </b-form-group>
        </b-col>
        <b-col
          v-if="addForm.type === 'NICU'"
          md="12"
          cols="12"
        >
          <AutoComplete
            v-model="addForm.incubator_id"
            :label="$t('incubator.incubator')"
            :placeholder="$t('incubator.incubator')"
            param-query="name"
            :serializer="(val) => val.id"
            endpoint="incubators"
            text-title="name"
            include="incubatorType"
            other-query="filter[is_available]=1"
            keyword="name"
          />
          <p class="text-danger mt-1">
            {{ errorForm.incubator_id }}
          </p>
        </b-col>

        <!-- Duration Presets for NICU -->
        <b-col
          v-if="addForm.type === 'NICU'"
          md="12"
        >
          <b-form-group :label="$t('incubator.duration-preset')">
            <b-form-radio-group
              v-model="nicuPresetDuration"
              :options="nicuDurationOptions"
              buttons
              button-variant="outline-primary"
              size="sm"
            />
          </b-form-group>
        </b-col>

        <!-- Duration Days Input (shown for both 1 day and custom) -->
        <b-col
          v-if="addForm.type === 'NICU'"
          md="6"
          cols="12"
        >
          <b-form-group
            :label="$t('incubator.duration-days')"
            label-for="duration_days"
          >
            <b-form-input
              v-if="nicuPresetDuration === 'custom'"
              id="duration_days"
              v-model.number="customDays"
              type="number"
              min="1"
              :placeholder="$t('incubator.duration-days')"
            />
            <b-form-input
              v-else
              id="duration_days_1"
              :value="1"
              type="number"
              disabled
            />
            <small class="text-muted">
              {{ $t("incubator.enter-number-of-days") }}
            </small>
            <p class="text-danger mt-1">
              {{ errorForm.custom_days }}
            </p>
          </b-form-group>
        </b-col>

        <!-- Invoices Section -->
        <b-col cols="12">
          <div class="section-divider">
            <feather-icon
              icon="FileTextIcon"
              size="20"
              class="section-icon"
            />
            <h4 class="section-title">
              {{ $t("common.invoices") }}
            </h4>
          </div>
        </b-col>
        <b-col
          md="12"
          cols="12"
        >
          <ServicePriceAutoComplete
            v-model="selectedServices"
            :label="$t('hospital.services')"
            :placeholder="$t('hospital.services')"
            :serializer="(val) => val"
            param-query="search"
            text-title="title"
            :multiple="true"
            md="6"
            @val="handleServicesChange"
            @total-price="handleTotalPrice"
          />
        </b-col>
      </b-row>
      <!-- Add Button -->

      <b-col
        cols="12"
        md="12"
        class="mt-2 d-flex align-items-center justify-content-between mb-1 mb-md-0"
      >
        <!-- <b-button
          v-if="isDevelopment"
          variant="warning"
          size="sm"
          :disabled="loading"
          @click="createTestPatient"
        >
          <b-spinner v-if="loading" small class="mr-1" />
          {{ $t("common.test") }}
        </b-button> -->
        <b-button
          style="margin: auto"
          variant="primary"
          @click="patientId ? updatePatient() : registerPatient()"
        >
          {{ patientId ? $t("common.update") : $t("common.submit") }}
        </b-button>
      </b-col>
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormGroup,
  // BFormSelect, // Commented: not currently used
  BSpinner,
  // BCardText, // Commented: not currently used
  // BInputGroup, // Commented: not currently used
  // BInputGroupAppend, // Commented: not currently used
  BFormTextarea,
  BFormCheckbox,
  BImg,
  BModal,
  BFormRadioGroup,
  BIconInfoCircle,
  BAlert,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
// import VueHtml2pdf from 'vue-html2pdf' // Commented: not currently used
import Datepicker from 'vuejs-datepicker'
import hospitalBranding from '@/config/hospitalBranding'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SurgeryCategorySelect from '@/components/surgery/SurgeryCategorySelect.vue'

const AutoComplete = () => import('@/components/common/AutoComplete.vue')
const ServicePriceAutoComplete = () => import('@/components/common/ServicePriceAutoComplete.vue')

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BImg,
    BFormInput,
    BButton,
    vSelect,
    BFormGroup,
    BSpinner,
    BFormTextarea,
    BFormCheckbox,
    BFormRadioGroup,
    Datepicker,
    AutoComplete,
    VuePhoneNumberInput,
    ServicePriceAutoComplete,
    BModal,
    BIconInfoCircle,
    BAlert,
    SurgeryCategorySelect,
  },

  data() {
    return {
      addForm: {
        name: '',
        mother_name: '',
        phone: '',
        birth_date: '',
        marital_status: '',
        education_level: '',
        residence_type: '',
        governorate_id: '',
        judiciary: '',
        town_name: '',
        city_name: '',
        district_name: '',
        street_name: '',
        building_number: '',
        child_name: '',
        document_page_number: '',
        document_number: '',
        department_of_civil_status: '',
        national_id: '',
        type: '',
        room_id: '',
        incubator_id: '',
        doctor_incubator_id: '',
        start_time: '',
        paid_until: '',
        custom_days: '',
        occupation: '',
        next_of_kin_phone_number: '',
        next_of_kin_name: '',
        companion_phone: '',
        full_companion_name: '',
        gender: '',
        service_id: '',
        status: 'pending',
        amount: 0,
      },
      errorForm: {
        name: '',
        mother_name: '',
        phone: '',
        birth_date: '',
        marital_status: '',
        education_level: '',
        residence_type: '',
        governorate_id: '',
        next_of_kin_phone_number: '',
        next_of_kin_name: '',
        companion_phone: '',
        full_companion_name: '',
        judiciary_name: '',
        town_name: '',
        city_name: '',
        district_name: '',
        street_name: '',
        building_number: '',
        child_name: '',
        document_page_number: '',
        document_number: '',
        department_of_civil_status: '',
        national_id: '',
        type: '',
        room_id: '',
        doctor_id: '',
        incubator_id: '',
        doctor_incubator_id: '',
        start_time: '',
        paid_until: '',
        custom_days: '',
        occupation: '',
        gender: '',
        service_id: '',
        status: 'pending',
        amount: 0,
        surgery_date_time: '',
        surgery_price: '',
      },
      genderOption: ['Male', 'Female'],
      maritalStatusOptions: ['single', 'married', 'divorced', 'widowed'],
      educationalLevelOptions: [
        'elementary-school',
        'middle-school',
        'high-school',
        'bachelor',
        'master',
        'phd',
        'illiterate',
        'can-read-and-write',
      ],
      residenceOptions: ['city', 'countryside'],

      // NICU duration presets
      nicuPresetDuration: '1day',
      nicuDurationOptions: [
        { text: `1 ${this.$t('incubator.day')}`, value: '1day' },
        { text: this.$t('incubator.custom'), value: 'custom' },
      ],
      customDays: 1, // Default custom days

      invoices: [],
      selectedServices: [],
      totalAmount: 0,
      hospitalLogo: hospitalBranding.logo,
      isNotValid: false,
      consultations: [
        {
          doctor_id: null,
          doctor_price: 0,
        },
      ],
      allDoctors: [],

      params: {
        form: {},
        path: '',
      },
      surgeryTypesList: [
        {
          text: 'كبرى ',
          value: '1',
        },
        {
          text: 'صغرى ',
          value: '2',
        },
        {
          text: 'متوسطة',
          value: '3',
        },
        {
          text: 'فوق الكبرى',
          value: '4',
        },
        {
          text: 'خاصة',
          value: '5',
        },
      ],
      patientId: this.$route.params.id,
      doctorsId: null,
      selectedAvailableSurgeries: null,
      doctorsName: '',
      surgeryForm: {
        title: '',
        description: '',
        type: 0,
        price: 0,
        surgery_category_id: null,
      },
      // price to be charged for the selected surgery when creating an IN patient
      patientSurgeryPrice: null,
      // date/time for the surgery when creating an IN patient
      patientSurgeryDateTime: '',
      paramsForDoctorSurgery: {
        form: {
          doctor_id: '',
          surgery_id: '',
          price: 0,
        },
        path: '/doctorSurgery',
      },
      paramsForSurgery: {
        form: {
          title: '',
          description: '',
          type: 0,
          price: 0,
          surgery_category_id: null,
        },
        path: '/surgery',
      },
      loading: false,
      dateWithTime: new Date().toISOString().slice(0, 16).replace('T', ' '),
      treatment_type: '',
      selectedDoctors: [],
      doctors: [],
      testNames: [
        'mona ameer',
        'ahmed ali',
        'sara khalid',
        'omar hassan',
        'fatima noor',
        'youssef karim',
        'layla mahmoud',
        'hamza salem',
        'noor abdullah',
        'zainab mustafa',
      ],
      testMotherNames: [
        'noor kadim',
        'huda hassan',
        'amira ali',
        'maryam khalid',
        'salma omar',
        'rania youssef',
        'leena ahmed',
        'dina salem',
      ],
      testPhones: [
        '07772323232',
        '07781234567',
        '07793456789',
        '07704567890',
        '07715678901',
        '07726789012',
        '07737890123',
        '07748901234',
      ],
      testCities: [
        'dora',
        'karrada',
        'mansour',
        'sadr city',
        'kadhimiya',
        'adhamiya',
        'zayouna',
        'baghdad jadida',
      ],
      testOccupations: [
        'engineer',
        'doctor',
        'teacher',
        'accountant',
        'nurse',
        'lawyer',
        'pharmacist',
        'architect',
      ],
      testNationalIds: [
        '3223444',
        '4445566',
        '7778899',
        '1122334',
        '5566778',
        '9988776',
        '6655443',
        '3344221',
      ],
      showAdditionalInfo: false,
      patientAge: null, // Store the age input by user
    }
  },

  computed: {
    isDevelopment() {
      return process.env.NODE_ENV === 'development'
    },
    minDateTime() {
      // Get current date and time in YYYY-MM-DDTHH:mm format (strict - no past dates allowed)
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day}T${hours}:${minutes}`
    },
    defaultSurgeryDateTime() {
      // Get current date and time + 1 hour in YYYY-MM-DDTHH:mm format
      const now = new Date()
      now.setHours(now.getHours() + 1)
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day}T${hours}:${minutes}`
    },
    availableConsultationDoctors() {
      // Combine all doctors with selected doctors from IN type
      const combinedDoctors = [...this.allDoctors]

      // Add selected doctors from IN type if they're not already in allDoctors
      if (this.addForm.type === 'IN' && this.selectedDoctors.length > 0) {
        this.selectedDoctors.forEach(selectedDoctor => {
          const doctorId = typeof selectedDoctor === 'object'
            ? selectedDoctor.id
            : selectedDoctor
          const exists = combinedDoctors.find(doc => doc.id === doctorId)
          if (!exists && typeof selectedDoctor === 'object') {
            combinedDoctors.push({
              id: selectedDoctor.id,
              name: selectedDoctor.name,
              type: selectedDoctor.type,
            })
          }
        })
      }

      return combinedDoctors
    },
  },

  watch: {
    'addForm.type': {
      handler(newType, oldType) {
        // Reload doctors when card type changes
        if (newType !== oldType) {
          this.selectedDoctors = [] // Clear selected doctors
          this.getDoctors()
        }
        // Calculate paid_until when NICU is selected
        if (newType === 'NICU') {
          this.calculatePaidUntil()
        }
      },
    },
    customDays: {
      handler() {
        // Auto-calculate paid_until when customDays changes (for NICU custom)
        if (
          this.addForm.type === 'NICU'
          && this.nicuPresetDuration === 'custom'
        ) {
          this.calculatePaidUntil()
        }
      },
    },
    nicuPresetDuration: {
      handler() {
        // Auto-calculate paid_until when preset changes (for NICU)
        if (this.addForm.type === 'NICU') {
          this.calculatePaidUntil()
        }
      },
    },
    selectedAvailableSurgeries: {
      handler(val) {
        try {
          if (!val) {
            // Only clear price if it was 0, otherwise preserve user-entered value
            if (
              this.patientSurgeryPrice === 0
              || this.patientSurgeryPrice === null
            ) {
              this.patientSurgeryPrice = null
            }
            this.patientSurgeryDateTime = ''
            return
          }
          const surgeryData = typeof val === 'object' ? val : null
          const derivedPrice = surgeryData && surgeryData.price ? Number(surgeryData.price) : null

          // Only set price from surgery if:
          // 1. Surgery has a valid price > 0, AND
          // 2. Current price is null or 0 (don't overwrite user-entered price)
          if (
            derivedPrice !== null
            && !Number.isNaN(derivedPrice)
            && derivedPrice > 0
            && (this.patientSurgeryPrice === null
              || this.patientSurgeryPrice === 0)
          ) {
            this.patientSurgeryPrice = derivedPrice
          } else if (
            (derivedPrice === null
              || derivedPrice === 0
              || Number.isNaN(derivedPrice))
            && (this.patientSurgeryPrice === null
              || this.patientSurgeryPrice === 0)
          ) {
            // Only set to null if surgery has no price and current value is 0 or null
            this.patientSurgeryPrice = null
          }
          // If user has already entered a price, preserve it

          // Set default surgery date to now + 1 hour (always set when surgery is selected)
          this.patientSurgeryDateTime = this.defaultSurgeryDateTime
        } catch (e) {
          // Don't reset price on error, preserve current value
          this.patientSurgeryDateTime = ''
        }
      },
    },
    treatment_type: {
      handler(newVal) {
        // Set default surgery date when treatment type changes to Surgery
        if (newVal === 'Surgery') {
          // Set default date immediately when Surgery is selected
          this.patientSurgeryDateTime = this.defaultSurgeryDateTime
        } else if (newVal !== 'Surgery') {
          // Clear date when treatment type is not Surgery
          this.patientSurgeryDateTime = ''
        }
      },
    },
    selectedDoctors: {
      handler(newDoctors, oldDoctors) {
        // Only auto-add to consultations if type is IN
        if (
          this.addForm.type === 'IN'
          && Array.isArray(newDoctors)
          && newDoctors.length > 0
        ) {
          // Get IDs of currently selected doctors
          const newDoctorIds = newDoctors.map(doc => (typeof doc === 'object' ? doc.id : doc))

          // First, remove all empty consultation entries
          this.consultations = this.consultations.filter(
            c => c.doctor_id !== null && c.doctor_id !== '',
          )

          // Get IDs of doctors already in consultations (after removing empty ones)
          const existingConsultationDoctorIds = this.consultations.map(
            c => c.doctor_id,
          )

          // Find newly added doctors (not in consultations yet)
          const doctorsToAdd = newDoctors.filter(doctor => {
            const doctorId = typeof doctor === 'object' ? doctor.id : doctor
            return !existingConsultationDoctorIds.includes(doctorId)
          })

          // Add new doctors to consultations with default price 0
          doctorsToAdd.forEach(doctor => {
            const doctorId = typeof doctor === 'object' ? doctor.id : doctor
            this.consultations.push({
              doctor_id: doctorId,
              doctor_price: 0,
            })
          })

          // Remove doctors from consultations if they were removed from selectedDoctors
          if (oldDoctors && Array.isArray(oldDoctors)) {
            const oldDoctorIds = oldDoctors.map(doc => (typeof doc === 'object' ? doc.id : doc))
            const removedDoctorIds = oldDoctorIds.filter(
              id => !newDoctorIds.includes(id),
            )

            // Remove consultations for doctors that are no longer selected
            this.consultations = this.consultations.filter(
              consultation => !removedDoctorIds.includes(consultation.doctor_id),
            )
          }
        } else if (
          this.addForm.type === 'IN'
          && (!newDoctors || newDoctors.length === 0)
        ) {
          // If no doctors selected, ensure at least one empty consultation entry
          this.consultations = [
            {
              doctor_id: null,
              doctor_price: 0,
            },
          ]
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.getDoctors()
    this.getAllDoctors()
    this.patientId = this.$route.params.id
    if (this.patientId) {
      this.getPatient()
    }
  },

  methods: {
    validateSurgeryDateTime() {
      // Clear error when user starts typing
      if (!this.patientSurgeryDateTime) {
        this.errorForm.surgery_date_time = ''
        return
      }

      const selectedDateTime = new Date(this.patientSurgeryDateTime)
      const now = new Date()

      // Check if date is in the past (even 1 minute)
      if (selectedDateTime <= now) {
        this.errorForm.surgery_date_time = 'تاريخ ووقت الجراحة يجب أن يكون في المستقبل (على الأقل دقيقة واحدة من الآن)'
      } else {
        this.errorForm.surgery_date_time = ''
      }
    },
    validateSurgeryPrice() {
      // Clear error when user starts typing
      if (!this.patientSurgeryPrice && this.patientSurgeryPrice !== 0) {
        this.errorForm.surgery_price = ''
        return
      }

      const price = Number(this.patientSurgeryPrice)
      if (!price || price <= 0) {
        this.errorForm.surgery_price = 'سعر الجراحة يجب أن يكون أكبر من الصفر'
      } else {
        this.errorForm.surgery_price = ''
      }
    },
    calculateBirthDateFromAge(age) {
      if (!age || age < 0) {
        this.addForm.birth_date = ''
        return
      }

      // Calculate birth year: current year - age
      const currentYear = new Date().getFullYear()
      const birthYear = currentYear - age

      // Set to January 1st of calculated year
      this.addForm.birth_date = `${birthYear}-01-01`
    },

    getRandomItem(array) {
      return array[Math.floor(Math.random() * array.length)]
    },

    getRandomBirthDate() {
      const year = 1950 + Math.floor(Math.random() * 50) // 1950-2000
      const month = String(Math.floor(Math.random() * 12) + 1).padStart(2, '0')
      const day = String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    async createTestPatient() {
      try {
        this.loading = true

        // Fetch governorates
        const governoratesResponse = await this.getList('governorate?take=100')
        const governorates = governoratesResponse.data.data
        if (!governorates || governorates.length === 0) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'No governorates available',
            },
          })
          this.loading = false
          return
        }

        // Fetch doctors
        const doctorsResponse = await this.getList('doctor?take=100')
        const doctors = doctorsResponse.data.data
        if (!doctors || doctors.length === 0) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'No doctors available',
            },
          })
          this.loading = false
          return
        }

        // Fetch available rooms
        const roomsResponse = await this.getList('available-room?take=100')
        const rooms = roomsResponse.data.data
        if (!rooms || rooms.length === 0) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'warning',
              text: 'No available rooms! Cannot create IN patient.',
            },
          })
          this.loading = false
          return
        }

        // Fetch services for invoices
        const servicesResponse = await this.getList(
          'service?filter[type]=regular&take=100',
        )
        const services = servicesResponse.data.data
        if (!services || services.length === 0) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'No services available',
            },
          })
          this.loading = false
          return
        }

        // Select random items
        const randomGovernorate = this.getRandomItem(governorates)
        const randomRoom = this.getRandomItem(rooms)
        const randomDoctor = this.getRandomItem(doctors)

        // Select 2 random services for invoices
        const service1 = this.getRandomItem(services)
        const service2 = this.getRandomItem(
          services.filter(s => s.id !== service1.id),
        )

        // Fill form fields with test data
        this.addForm.name = this.getRandomItem(this.testNames)
        this.addForm.mother_name = this.getRandomItem(this.testMotherNames)
        this.addForm.phone = this.getRandomItem(this.testPhones)

        // Set random age between 1 and 90
        const randomAge = Math.floor(Math.random() * 90) + 1
        this.patientAge = randomAge
        this.calculateBirthDateFromAge(randomAge)

        this.addForm.marital_status = this.getRandomItem(
          this.maritalStatusOptions,
        )
        this.addForm.education_level = this.getRandomItem(
          this.educationalLevelOptions,
        )
        this.addForm.residence_type = this.getRandomItem(this.residenceOptions)
        this.addForm.governorate_id = randomGovernorate.id
        this.addForm.city_name = this.getRandomItem(this.testCities)
        this.addForm.national_id = this.getRandomItem(this.testNationalIds)
        this.addForm.occupation = this.getRandomItem(this.testOccupations)
        this.addForm.type = 'IN'
        this.addForm.room_id = typeof randomRoom === 'object' ? randomRoom.id : randomRoom
        this.addForm.gender = this.getRandomItem(this.genderOption)

        // Set selected doctors for display
        this.selectedDoctors = [randomDoctor]

        // Set selected services for display
        this.selectedServices = [service1, service2]

        // Update invoices array
        this.invoices = [
          {
            service_id: service1.id,
            status: 'pending',
            amount: service1.price || 0,
          },
          {
            service_id: service2.id,
            status: 'pending',
            amount: service2.price || 0,
          },
        ]

        // Update total amount
        this.totalAmount = (service1.price || 0) + (service2.price || 0)
        this.addForm.amount = this.totalAmount

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Success',
            variant: 'success',
            text: 'Test data filled! Click submit to create patient.',
          },
        })
      } catch (error) {
        console.error('Test data fill error:', error)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            variant: 'danger',
            text: error.response?.data?.message || 'Failed to fill test data',
          },
        })
      } finally {
        this.loading = false
      }
    },

    async getDoctors() {
      // Use NICU-specific endpoint when card type is NICU
      const endpoint = this.addForm.type === 'NICU'
        ? 'doctor/nicu?take=10'
        : 'doctor?take=100'

      await this.getList(endpoint).then(response => {
        this.doctors = response.data.data.map(doctor => ({
          id: doctor.id,
          name: doctor.name,
          type: doctor.type,
        }))
      })
    },

    async getAllDoctors() {
      // Get all doctors for consultation selection
      await this.getList('doctor?take=1000').then(response => {
        this.allDoctors = response.data.data.map(doctor => ({
          id: doctor.id,
          name: doctor.name,
          type: doctor.type,
        }))
      })
    },

    addConsultation() {
      this.consultations.push({
        doctor_id: null,
        doctor_price: 0,
      })
    },

    removeConsultation(index) {
      if (this.consultations.length > 1) {
        this.consultations.splice(index, 1)
      }
    },

    onConsultationDoctorChange(index) {
      // Optional: You can add logic here if needed when doctor changes
    },

    // async formatForQuery(val) {
    //   this.doctorsName = this.getDoctorsName(val);
    //   this.availableSurgeriesOptions = [];
    //   this.availableSurgeries = [];
    //   let temp = ``;
    //   val.forEach((item) => {
    //     temp += `doctors[]=${item.id}&`;
    //   });
    //   this.doctorsId = temp;
    //   console.log("doctorsId", this.doctorsId);
    //   await this.getList(
    //     `surgery/availableSurgeriesForDoctors?${this.doctorsId}`     // show only available surgeries for the selected doctors
    //   );
    //   this.availableSurgeries = this.all_data;
    //   this.availableSurgeries.forEach((item) => {
    //     this.availableSurgeriesOptions.push({
    //       id: item.id,
    //       title: item.title,
    //     });
    //   });
    //   console.log("availableSurgeries", this.availableSurgeries);
    // },
    async formatForQuery(val) {
      this.doctorsName = this.getDoctorsName(val)
      // All surgeries are already loaded, no need to reload them
    },
    getDoctorsName(doctors) {
      let temp = ''
      doctors.forEach(item => {
        temp += `${item.name}, `
      })
      return temp
    },
    showCreateSurgeryModal() {
      this.$bvModal.show('modal-create-surgery')
    },
    async createSurgery() {
      this.loading = true
      try {
        this.paramsForSurgery.form = this.surgeryForm
        this.paramsForSurgery.path = '/surgery'
        this.$store
          .dispatch('create', this.paramsForSurgery)
          .then(async surgeryResponse => {
            // Link doctors to the created surgery
            const doctorSurgeryPromises = this.selectedDoctors.map(doctor => {
              this.paramsForDoctorSurgery.form = {
                doctor_id: doctor.id,
                surgery_id: surgeryResponse.data.data.id,
                price: 0,
              }
              this.paramsForDoctorSurgery.path = '/doctorSurgery'
              return this.$store.dispatch(
                'create',
                this.paramsForDoctorSurgery,
              )
            })

            await Promise.all(doctorSurgeryPromises)
            this.loading = false
            this.$bvModal.hide('modal-create-surgery')
            await this.formatForQuery(this.selectedDoctors)
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Success',
                variant: 'success',
                text: this.$t(
                  'reception.surgery-created-and-linked-to-doctors-successfully',
                ),
              },
            })
          })
          .catch(error => {
            this.loading = false
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Error',
                variant: 'danger',
                text:
                  error.response?.data?.message
                  || this.$t(
                    'reception.surgery-created-and-linked-to-doctors-error',
                  ),
              },
            })
          })
      } catch (error) {
        this.loading = false
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            variant: 'danger',
            text:
              error.response?.data?.message
              || this.$t('reception.surgery-created-and-linked-to-doctors-error'),
          },
        })
      }
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid
      if (countryCallingCodeCheck) {
        this.countryCallingCodeFirst = obj.countryCallingCode
      } else {
        this.countryCallingCodeSecond = obj.countryCallingCode
      }
    },

    handleServicesChange(services) {
      this.selectedServices = services
      // Convert selected services to invoices format
      if (Array.isArray(services)) {
        this.invoices = services.map(service => ({
          service_id: service.id,
          status: 'pending',
          amount: service.price || 0,
        }))
      } else if (services) {
        this.invoices = [
          {
            service_id: services.id,
            status: 'pending',
            amount: services.price || 0,
          },
        ]
      } else {
        this.invoices = []
      }
    },

    handleTotalPrice(total) {
      this.totalAmount = total
      this.addForm.amount = total
    },

    formatDate(date) {
      const newDate = new Date(date)
      const year = newDate.getFullYear()
      const month = String(newDate.getMonth() + 1).padStart(2, '0')
      const day = String(newDate.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    },

    calculatePaidUntil() {
      // Calculate paid_until based on current time and duration (days)
      // Set start_time to current time
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')

      // Set start_time to current datetime (format: YYYY-MM-DD HH:mm)
      this.addForm.start_time = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`

      let daysToAdd = 1 // Default to 1 day

      if (this.nicuPresetDuration === 'custom') {
        daysToAdd = this.customDays || 1
      }

      // Convert days to hours and add to current time
      const hoursToAdd = daysToAdd * 24
      const endDate = new Date(now.getTime() + hoursToAdd * 60 * 60 * 1000)

      // Format as datetime string (YYYY-MM-DD HH:mm) - matching backend format
      const endYear = endDate.getFullYear()
      const endMonth = String(endDate.getMonth() + 1).padStart(2, '0')
      const endDay = String(endDate.getDate()).padStart(2, '0')
      const endHours = String(endDate.getHours()).padStart(2, '0')
      const endMinutes = String(endDate.getMinutes()).padStart(2, '0')
      const endSeconds = String(endDate.getSeconds()).padStart(2, '0')

      // Format as "YYYY-MM-DD HH:mm" for backend (space instead of T)
      this.addForm.paid_until = `${endYear}-${endMonth}-${endDay} ${endHours}:${endMinutes}:${endSeconds}`
    },
    // doctorValue(doctor, index) {
    //   this.currentDoctor = doctor;
    //   this.doctors[index] = this.currentDoctor;
    // },
    async getPatient() {
      await this.getList(`patient/${this.patientId}`)
      this.addForm = {
        ...this.all_data,
      }

      // Calculate age from birth_date when editing
      if (this.addForm.birth_date) {
        const birthDate = new Date(this.addForm.birth_date)
        const currentYear = new Date().getFullYear()
        const birthYear = birthDate.getFullYear()
        this.patientAge = currentYear - birthYear
      }
    },

    updatePatient() {
      Object.keys(this.errorForm).forEach(item => {
        this.errorForm[item] = ''
        if (this.addForm[item] === '' || this.addForm[item] === null) {
          delete this.addForm[item]
        }
      })

      // Validate form before submission
      if (!this.formValid()) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Validation Error',
            variant: 'danger',
            text: 'Please fill in all required fields correctly.',
          },
        })
        return
      }

      this.addForm.birth_date = this.formatDate(this.addForm.birth_date)

      // Ensure governorate_id is just the ID string
      if (
        this.addForm.governorate_id
        && typeof this.addForm.governorate_id === 'object'
      ) {
        this.addForm.governorate_id = this.addForm.governorate_id.id
      }

      // eslint-disable-next-line no-underscore-dangle
      this.addForm._method = 'PUT'

      this.params.form = this.addForm
      this.params.path = `patient/${this.patientId}`
      this.$store
        .dispatch('update', this.params)
        .then(async () => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Updated',
              variant: 'success',
            },
          })

          this.$router.push({
            name: 'Reception-Departments',
          })
        })
        .catch(error => {
          if (error.response.status === 400) {
            Object.keys(error.response.data).forEach(item => {
              const [errorMessage] = error.response.data[item]
              this.errorForm[item] = errorMessage
            })
            Object.keys(error.response.data).forEach(item => {
              const [errorMessage] = error.response.data[item]
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'validation error',
                  variant: 'danger',
                  text: errorMessage,
                },
              })
            })
          }
        })
    },

    async createPatientSurgery(response) {
      try {
        // Use the user-provided surgery date/time if available, otherwise use current time
        let surgeryDateTime
        if (this.patientSurgeryDateTime) {
          // Convert from datetime-local format (YYYY-MM-DDTHH:mm) to backend format (YYYY-MM-DD HH:mm)
          const dateObj = new Date(this.patientSurgeryDateTime)
          surgeryDateTime = `${dateObj.getFullYear()}-${String(
            dateObj.getMonth() + 1,
          ).padStart(2, '0')}-${String(dateObj.getDate()).padStart(
            2,
            '0',
          )} ${String(dateObj.getHours()).padStart(2, '0')}:${String(
            dateObj.getMinutes(),
          ).padStart(2, '0')}`
        } else {
          // Fallback to current time if no date is provided
          const now = new Date()
          surgeryDateTime = `${now.getFullYear()}-${String(
            now.getMonth() + 1,
          ).padStart(2, '0')}-${String(now.getDate()).padStart(
            2,
            '0',
          )} ${String(now.getHours()).padStart(2, '0')}:${String(
            now.getMinutes(),
          ).padStart(2, '0')}`
        }

        const surgeryPayload = {
          patient_card_id: response.data.card.data.id,
          surgery_id: this.selectedAvailableSurgeries.id,
          surgery_date_time: surgeryDateTime,
          doctors: this.selectedDoctors.map(doctor => ({
            id: doctor.id,
            type: doctor.type,
          })),
        }

        // Only include price if it's greater than 0
        const surgeryPrice = Number(this.patientSurgeryPrice)
        if (surgeryPrice && surgeryPrice > 0) {
          surgeryPayload.price = surgeryPrice
        }

        await this.$store.dispatch('create', {
          form: surgeryPayload,
          path: 'patient-surgery',
        })

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Surgery Scheduled',
            variant: 'success',
          },
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Surgery Creation Error',
            variant: 'danger',
            text:
              error.response?.data?.message
              || this.$t('reception.surgery-creation-error'),
          },
        })
        throw error // Re-throw error if you need to handle it in the caller
      }
    },

    async createPatientBedRest(response) {
      try {
        const now = new Date()
        const stayDateTime = `${now.getFullYear()}-${String(
          now.getMonth() + 1,
        ).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(
          now.getHours(),
        ).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`

        const bedRestPayload = {
          patient_card_id: response.data.card.data.id, // Assuming you have patient card data
          stay_date_time: stayDateTime,
          doctors: this.selectedDoctors.map(doctor => doctor.id), // Assuming you have doctors array
        }

        await this.$store.dispatch('create', {
          form: bedRestPayload,
          path: 'patient-stay',
        })

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Bed Rest Created',
            variant: 'success',
            text: 'Patient bed rest has been created successfully',
          },
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            variant: 'danger',
            text: 'Failed to create bed rest',
          },
        })
        console.error('Error creating bed rest:', error)
      }
    },

    registerPatient() {
      Object.keys(this.errorForm).forEach(item => {
        this.errorForm[item] = ''
        if (this.addForm[item] === '' || this.addForm[item] === null) {
          delete this.addForm[item]
        }
      })

      // Validate form before submission
      if (!this.formValid()) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Validation Error',
            variant: 'danger',
            text: 'Please fill in all required fields correctly.',
          },
        })
        return
      }

      // Check if surgery date/time is in the past (even 1 minute)
      if (this.patientSurgeryDateTime) {
        const selectedDateTime = new Date(this.patientSurgeryDateTime)
        const now = new Date()
        // Add 1 minute buffer to ensure no past dates are allowed
        if (selectedDateTime <= now) {
          this.errorForm.surgery_date_time = 'تاريخ ووقت الجراحة يجب أن يكون في المستقبل (على الأقل دقيقة واحدة من الآن)'
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Validation Error',
              variant: 'danger',
              text: 'Surgery date and time must be in the future (at least 1 minute from now).',
            },
          })
          return
        }
        this.errorForm.surgery_date_time = ''
      }

      // Filter out any surgery invoices - surgeries should not be sent in invoices
      const invoicesWithoutSurgeries = this.invoices.filter(
        invoice => !invoice.surgery_id,
      )
      this.addForm.invoices = invoicesWithoutSurgeries
      this.addForm.birth_date = this.formatDate(this.addForm.birth_date)

      // Format consultations - filter out empty ones, ones with 0 price, and ensure proper structure
      const validConsultations = this.consultations
        .filter(
          consultation => consultation.doctor_id !== null
            && consultation.doctor_id !== ''
            && Number(consultation.doctor_price) > 0,
        )
        .map(consultation => ({
          doctor_id: consultation.doctor_id,
          doctor_price: Number(consultation.doctor_price),
        }))

      // Only add consultations if there are valid ones
      if (validConsultations.length > 0) {
        this.addForm.consultations = validConsultations
      } else {
        delete this.addForm.consultations
      }

      // Handle doctors based on type
      if (this.addForm.type === 'NICU') {
        // For NICU, send both doctors array and doctor_incubator_id
        this.addForm.doctors = [
          ...this.selectedDoctors.map(doctor => doctor.id),
        ]
        // Set doctor_incubator_id from the first selected doctor
        if (this.selectedDoctors.length > 0) {
          this.addForm.doctor_incubator_id = this.selectedDoctors[0].id
        }
      } else {
        // For other types, use doctors array only
        this.addForm.doctors = [
          ...this.selectedDoctors.map(doctor => doctor.id),
        ]
        // Ensure doctor_incubator_id is not sent for non-NICU types
        delete this.addForm.doctor_incubator_id
      }

      // Delete room_id if IN type but treatment_type is None (before ID conversion)
      if (this.addForm.type === 'IN' && this.treatment_type === 'None') {
        delete this.addForm.room_id
      }

      // Ensure room_id is just the ID string, not the full object
      if (this.addForm.room_id && typeof this.addForm.room_id === 'object') {
        this.addForm.room_id = this.addForm.room_id.id
      }

      // Ensure governorate_id is just the ID string
      if (
        this.addForm.governorate_id
        && typeof this.addForm.governorate_id === 'object'
      ) {
        this.addForm.governorate_id = this.addForm.governorate_id.id
      }

      // Ensure incubator_id is just the ID string
      if (
        this.addForm.incubator_id
        && typeof this.addForm.incubator_id === 'object'
      ) {
        this.addForm.incubator_id = this.addForm.incubator_id.id
      }

      if (this.addForm.type !== 'IN' && this.addForm.type !== 'NICU') {
        delete this.addForm.doctor_id
        delete this.addForm.room_id
        delete this.addForm.incubator_id
        delete this.addForm.start_time
      }

      // Delete room_id for NICU since we use incubator_id instead
      if (this.addForm.type === 'NICU') {
        delete this.addForm.room_id
      }

      // Delete incubator_id and start_time for non-NICU types
      if (this.addForm.type !== 'NICU') {
        delete this.addForm.incubator_id
        delete this.addForm.start_time
        delete this.addForm.paid_until
      } else {
        // Calculate paid_until for NICU based on start_time and duration
        this.calculatePaidUntil()
      }

      // if (!this.formValid()) return;
      // return 0;
      this.params.form = this.addForm
      this.params.path = 'patientWithCard'
      this.$store
        .dispatch('create', this.params)
        .then(async response => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Created',
              variant: 'success',
            },
          })
          if (
            this.treatment_type === 'Surgery'
            && this.selectedAvailableSurgeries
          ) {
            await this.createPatientSurgery(response)
          }
          if (this.treatment_type === 'Bed Rest') {
            await this.createPatientBedRest(response)
          }

          this.$router.push({
            name: 'Reception-Lobby',
          })
        })
        .catch(error => {
          if (error.response.status === 400) {
            Object.keys(error.response.data).forEach(item => {
              const [errorMessage] = error.response.data[item]
              this.errorForm[item] = errorMessage
            })
            Object.keys(error.response.data).forEach(item => {
              const [errorMessage] = error.response.data[item]
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'validation error',
                  variant: 'danger',
                  text: errorMessage,
                },
              })
            })
          }
        })
    },
    formValid() {
      const requiredFields = {
        name: 'The name field is required.',
        mother_name: 'The mother name field is required.',
        gender: 'The gender field is required.',
        birth_date: [
          'The birth date field must be a valid date.',
          'The birth date field must match the format Y-m-d.',
        ],
        phone: 'The phone field is required.',
        governorate_id: 'The governorate id field is required.',
        type: 'The type field is required.',
      }

      if (this.patientId) {
        delete requiredFields.type
      }

      let isValid = true

      Object.keys(requiredFields).forEach(field => {
        if (!this.addForm[field] || this.addForm[field] === '') {
          this.errorForm[field] = Array.isArray(requiredFields[field])
            ? requiredFields[field][0]
            : requiredFields[field]
          isValid = false
        } else {
          this.errorForm[field] = ''
        }
      })

      // Additional check for birth_date format
      if (
        this.addForm.birth_date
        && !/^\d{4}-\d{2}-\d{2}$/.test(this.addForm.birth_date)
      ) {
        const [, birthDateFormatError] = requiredFields.birth_date
        this.errorForm.birth_date = birthDateFormatError
        isValid = false
      }

      // Check for child_name when type is NICU
      if (this.addForm.type === 'NICU') {
        if (!this.addForm.child_name || this.addForm.child_name === '') {
          this.errorForm.child_name = 'The child name field is required.'
          isValid = false
        } else {
          this.errorForm.child_name = ''
        }

        // Check for incubator when type is NICU
        if (!this.addForm.incubator_id) {
          this.errorForm.incubator_id = 'The incubator field is required for NICU patients.'
          isValid = false
        } else {
          this.errorForm.incubator_id = ''
        }
      }

      // Check for surgery details when treatment type is Surgery
      if (this.addForm.type === 'IN' && this.treatment_type === 'Surgery') {
        if (!this.selectedAvailableSurgeries) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Validation Error',
              variant: 'warning',
              text: 'Please select a surgery for surgery treatment type.',
            },
          })
          isValid = false
        }

        if (!this.selectedDoctors || this.selectedDoctors.length === 0) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Validation Error',
              variant: 'warning',
              text: 'Please select at least one doctor for surgery.',
            },
          })
          isValid = false
        }

        // Validate surgery price - must be greater than 0
        const surgeryPrice = Number(this.patientSurgeryPrice)
        if (!surgeryPrice || surgeryPrice <= 0) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Validation Error',
              variant: 'warning',
              text: 'Surgery price must be greater than 0.',
            },
          })
          isValid = false
        }
      }

      return isValid
    },
  },
}
</script>
<style scoped>
.text {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 0.5fr 1.5fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "arabic-name arabic-name arabic-name"
    "arabic-name arabic-name arabic-name"
    "english-name english-name english-name"
    "logo logo logo";
  grid-area: text;
}
.logo {
  grid-area: logo;
  margin: auto;
}
.arabic-name {
  font-family: "Arabic Typesetting", "Tahoma", "Times New Roman", "Arial", serif;
  grid-area: arabic-name;
  font-size: xxx-large;
  font-weight: 900;
  color: #070050;
  margin: auto;
}

.english-name {
  font-family: "Arabic Typesetting", "Tahoma", "Times New Roman", "Arial", serif;
  grid-area: english-name;
  font-size: xxx-large;
  font-weight: 900;
  margin: auto;
  color: #070050;
}
.error {
  color: rgb(255, 0, 0) !important;
}
.required::before {
  content: " *";
  color: red;
  font-weight: bold;
  position: absolute;
  top: -10px;
}

/* Container styling */
.insurance-container {
  font-family: "Arial", sans-serif;
  max-width: 500px;
  margin: 2rem auto;
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 10px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
}

/* Radio button container */
.radio-group {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  width: 100%;
}

/* Custom radio button styling */
.radio-input {
  display: none;
}

.radio-label {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  cursor: pointer;
  color: #34495e;
  transition: all 0.3s ease;
  padding: 0.8rem 0.5rem;
  border-radius: 8px;
  background-color: white;
  border: 2px solid #e0e0e0;
  position: relative;
}

.radio-label:hover {
  border-color: #3498db;
  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.2);
}

/* Custom radio circle */
.radio-label::before {
  content: "";
  width: 20px;
  height: 20px;
  border: 2px solid #95a5a6;
  border-radius: 50%;
  transition: all 0.3s ease;
}

/* Selected state styling */
.radio-input:checked + .radio-label {
  border-color: #2ecc71;
  background-color: #f0fdf4;
}

.radio-input:checked + .radio-label::before {
  border-color: #2ecc71;
  background-color: #2ecc71;
  box-shadow: inset 0 0 0 4px white;
}

/* Focus state */
.radio-input:focus + .radio-label {
  outline: 2px solid #3498db;
  outline-offset: 2px;
} /* Radio button container */
.radio-group {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

/* Custom radio button styling */
.radio-input {
  display: none;
}

.radio-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
  color: #34495e;
  transition: all 0.3s ease;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  background-color: white;
  border: 2px solid #e0e0e0;
  width: 100%;
  box-sizing: border-box;
}

.radio-label:hover {
  border-color: #3498db;
  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.2);
}

/* Custom radio circle (left-aligned) */
.radio-label::before {
  content: "";
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border: 2px solid #95a5a6;
  border-radius: 50%;
  transition: all 0.3s ease;
}

/* Selected state styling */
.radio-input:checked + .radio-label {
  border-color: #2ecc71;
  background-color: #f0fdf4;
}

.radio-input:checked + .radio-label::before {
  border-color: #2ecc71;
  background-color: #2ecc71;
  box-shadow: inset 0 0 0 4px white;
}

/* Focus state */
.radio-input:focus + .radio-label {
  outline: 2px solid #3498db;
  outline-offset: 2px;
}

/* Text styling */
.radio-text {
  flex-grow: 1;
  font-size: 1.1rem;
  font-weight: 500;
}

.doctor-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  margin: 5px;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 200px;
  text-align: center;
}

.role-selection {
  margin-top: 10px;
}

.role-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.role-checkbox >>> .custom-control-label {
  font-size: 14px;
  color: #333;
}

.role-checkbox
  >>> .custom-control-input:checked
  ~ .custom-control-label::before {
  background-color: #007bff;
  border-color: #007bff;
}

.role-checkbox >>> .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* ========== Enhanced UI Styles ========== */

/* Hospital Header Card Enhancement */
.hospital-header-card {
  border-radius: 15px;
  transition: transform 0.3s ease;
}

.hospital-header-card:hover {
  transform: translateY(-5px);
}

/* Logo Animation */
@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.pulse-animation {
  animation: pulse 3s ease-in-out infinite;
}

/* Form Card Enhancement */
.form-card {
  border-radius: 15px;
  border: none;
  background: white;
}

/* Form Header */
.form-header {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 3px solid #f0f0f0;
}

.form-header h2 {
  color: #2c3e50;
  font-weight: 600;
}

/* Section Divider */
.section-divider {
  display: flex;
  align-items: center;
  margin: 25px 0 20px 0;
  padding: 15px;
  background: linear-gradient(90deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 10px;
  border-left: 4px solid #667eea;
}

.section-icon {
  color: #667eea;
  margin-right: 12px;
}

.section-title {
  margin: 0;
  color: #2c3e50;
  font-weight: 600;
  font-size: 1.1rem;
}

/* Additional Info Toggle Enhancement */
.additional-info-btn {
  margin: 20px 0;
  padding: 15px 20px;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.additional-info-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.additional-info-btn .when-open {
  display: none;
}

.additional-info-btn.not-collapsed .when-open {
  display: inline;
}

.additional-info-btn.not-collapsed .when-closed {
  display: none;
}

.additional-info-toggle {
  background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%);
  padding: 20px;
  border-radius: 12px;
  margin: 20px 0;
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;
}

.additional-info-toggle:hover {
  border-color: #667eea;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
}

.custom-switch-lg {
  font-size: 1.1rem;
}

.toggle-text {
  font-weight: 500;
  color: #2c3e50;
}

/* Form Input Enhancements */
.form-group label {
  font-weight: 500;
  color: #495057;
  margin-bottom: 8px;
}

.form-control:focus,
.vs__dropdown-toggle:focus-within {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}

/* Required Field Indicator */
.required label::after {
  content: " *";
  color: #dc3545;
  font-weight: bold;
}

/* Button Enhancements */
.btn-primary {
  border-radius: 8px;
  padding: 12px 30px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.btn-secondary {
  border-radius: 8px;
  padding: 12px 30px;
  font-weight: 500;
  transition: all 0.3s ease;
}

/* Card Spacing */
.card {
  margin-bottom: 20px;
}

/* Smooth Transitions for Collapsible Content */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Small Text Danger Enhancement */
.text-danger {
  font-size: 0.875rem;
  font-weight: 500;
  margin-top: 5px;
  display: block;
}

/* Loading State Enhancement */
.spinner-border {
  animation: spin 0.75s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Responsive Improvements */
@media (max-width: 768px) {
  .form-header h2 {
    font-size: 1.5rem;
  }

  .section-title {
    font-size: 1rem;
  }

  .additional-info-toggle {
    padding: 15px;
  }
}
</style>
